<side-nav-layout label="관리자" [homeUrl]="mainDomainUrl" rootLink="/admin" [menu]="menu">
  <router-outlet></router-outlet>
</side-nav-layout>
